import { AccordionDetails, Box, Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordion from "@mui/material/Accordion";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled(props =>
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1rem" }} />}
    {...props}
  />
)(({ theme }) => ({
  backgroundColor: "transparent",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)"
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1)
  }
}));

export default function Faqs() {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <Box
      sx={{
        textAlign: "left"
      }}
      id="faq"
    >
       <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography variant="h5">What is KeywordsFly?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          KeywordsFly is a results-driven Growth Marketing Company based
           in India that offers solutions with a new and amazing way to 
           launch, manage and grow your business online, generate qualified 
           sales, & leads with guaranteed brand building.
          </Typography>
        </AccordionDetails>
      </Accordion>
     <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary>
          <Typography variant="h5">
          Who can use KeywordsFly?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          KeywordsFly built an environment for entrepreneurs and 
          top-notch experts who can grow exponentially by going online. 
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary>
          <Typography variant="h5">
          What does KeywordsFly cost?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Setting up your webpage, domain, and maintenance at just 10 
          USD per month. For any extra services or customizations, you can always reach out to us
           or hire our listed specialist profiles. Custom pricing for large businesses is also available.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary>
          <Typography variant="h5">
          Can I create recurring workshops/classes?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Yes, you definitely can. KeywordsFly allows you to 
          conduct a variety of classes and workshops according 
          to your liking. The frequency, duration, timing, format,
           curriculum, etc. of classes, sessions, and workshops that
            you want to conduct are totally up to you!
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
